import { render, staticRenderFns } from "./Acopios.vue?vue&type=template&id=a171d690"
import script from "./Acopios.vue?vue&type=script&lang=js"
export * from "./Acopios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports